export default class UserProfile {
    FirstName: string = '';
    LastName: string = '';
    SecondName: string = '';
    Birthdate?: Date | null;
    Phone: string = '';
}